import { NgModule } from '@angular/core';
import { SearchResultsComponent } from './search-results.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MlsResultComponent } from './mls-result/mls-result.component';
import { SharedPipesModule } from '../../../shared/pipes/shared-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SharedPipesModule
  ],
  declarations: [
    MlsResultComponent,
    SearchResultsComponent
  ],
  exports: [
    SearchResultsComponent
  ]
})
export class SearchResultsModule { }
